import type { BillNotification, PushSubscriptionInput } from "@boo/shared";
import { request } from "./apiClient";

export interface NotificationList {
  unread: number;
  items: BillNotification[];
}

export const fetchNotifications = () =>
  request<NotificationList>("/notifications");

export const markNotificationRead = (id: string) =>
  request<void>(`/notifications/${id}/read`, { method: "PATCH" });

export const markAllNotificationsRead = () =>
  request<void>("/notifications/read-all", { method: "POST" });

export async function fetchVapidKey(): Promise<string | null> {
  const res = await request<{ publicKey: string | null }>("/push/vapid-key");
  return res.publicKey;
}

export const subscribePush = (sub: PushSubscriptionInput) =>
  request<void>("/push/subscribe", { method: "POST", data: sub });

export const unsubscribePush = (endpoint: string) =>
  request<void>("/push/subscribe", { method: "DELETE", data: { endpoint } });
